module.exports = __webpack_public_path__ + "static/media/eng_d_1999.e328c25a.mp4";